export default __webpack_public_path__ + "static/media/ls9.53abc152.png";